import { EnvironmentProviders, Provider } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { PlayerStatisticsEffects } from './player-statistics.effects';
import { playerStatisticsReducer } from './player-statistics.reducer';
import { playerStatisticsStateKey } from './player-statistics.state';

export function providePlayerStatistics(): (Provider | EnvironmentProviders)[] {
    return [provideState(playerStatisticsStateKey, playerStatisticsReducer), provideEffects(PlayerStatisticsEffects)];
}
